function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscovercarddisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "202px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.223
    },
    fill: "#b8b7b7",
    d: "M 6.5,-0.5 C 69.1667,-0.5 131.833,-0.5 194.5,-0.5C 197.167,1.5 199.5,3.83333 201.5,6.5C 201.5,44.5 201.5,82.5 201.5,120.5C 199.5,123.167 197.167,125.5 194.5,127.5C 131.833,127.5 69.1667,127.5 6.5,127.5C 3.83333,125.5 1.5,123.167 -0.5,120.5C -0.5,82.5 -0.5,44.5 -0.5,6.5C 1.5,3.83333 3.83333,1.5 6.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#f0efef",
    d: "M 1.5,101.5 C 48.8333,101.5 96.1667,101.5 143.5,101.5C 118.018,111.768 91.6847,119.435 64.5,124.5C 62.1944,124.993 59.861,125.326 57.5,125.5C 40.83,125.667 24.1633,125.5 7.5,125C 4.57192,123.74 2.73859,121.573 2,118.5C 1.50058,112.843 1.33391,107.176 1.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#f6f6f6",
    d: "M 1.5,83.5 C 61.8333,83.5 122.167,83.5 182.5,83.5C 170.168,90.8311 157.168,96.8311 143.5,101.5C 96.1667,101.5 48.8333,101.5 1.5,101.5C 1.5,95.5 1.5,89.5 1.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#fe6703",
    d: "M 199.5,73.5 C 200.661,87.9942 200.828,102.661 200,117.5C 199.15,122.332 196.316,124.999 191.5,125.5C 148.997,125.832 106.663,125.499 64.5,124.5C 91.6847,119.435 118.018,111.768 143.5,101.5C 157.168,96.8311 170.168,90.8311 182.5,83.5C 188.668,80.9196 194.335,77.5863 199.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#fdfcfc",
    d: "M 199.5,73.5 C 194.335,77.5863 188.668,80.9196 182.5,83.5C 122.167,83.5 61.8333,83.5 1.5,83.5C 1.33336,58.1645 1.50003,32.8311 2,7.5C 3.16667,5 5,3.16667 7.5,2C 69.5,1.33333 131.5,1.33333 193.5,2C 196,3.16667 197.833,5 199,7.5C 199.5,29.4975 199.667,51.4975 199.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#adadad",
    d: "M 158.5,65.5 C 159.451,66.9187 159.784,68.5853 159.5,70.5C 154.305,70.8205 149.305,70.4872 144.5,69.5C 144.833,69.5 145.167,69.5 145.5,69.5C 149.833,69.5 154.167,69.5 158.5,69.5C 158.5,68.1667 158.5,66.8333 158.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#ff7a25",
    d: "M 100.5,43.5 C 114.766,43.0574 120.266,49.7241 117,63.5C 108.177,73.101 99.8436,72.7676 92,62.5C 89.4545,53.6004 92.2878,47.2671 100.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#ff9149",
    d: "M 99.5,46.5 C 111.773,45.0583 116.607,50.3916 114,62.5C 108.23,67.689 102.563,67.689 97,62.5C 94.4534,56.5581 95.2868,51.2248 99.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#ffa468",
    d: "M 101.5,48.5 C 108.73,46.9073 112.73,49.7407 113.5,57C 113.592,59.8139 112.592,62.1473 110.5,64C 100.252,66.7519 96.0856,62.9185 98,52.5C 99.3756,51.2949 100.542,49.9616 101.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#ffb88a",
    d: "M 102.5,49.5 C 105.746,49.1351 108.412,50.1351 110.5,52.5C 112.602,59.822 109.935,62.9886 102.5,62C 99.0093,60.1792 97.8426,57.3458 99,53.5C 100.376,52.2949 101.542,50.9616 102.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#ffcfaf",
    d: "M 102.5,51.5 C 108.989,51.1563 110.989,53.9896 108.5,60C 101.144,60.7405 99.1445,57.9072 102.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#939393",
    d: "M 150.5,48.5 C 150.5,50.1667 150.5,51.8333 150.5,53.5C 153.385,53.1936 156.052,53.5269 158.5,54.5C 155.5,54.5 152.5,54.5 149.5,54.5C 149.205,52.2646 149.539,50.2646 150.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#0b0b0b",
    d: "M 162.5,43.5 C 166.915,43.3054 171.249,43.8054 175.5,45C 179.956,50.5206 179.289,55.3539 173.5,59.5C 175.711,62.7556 178.045,65.9223 180.5,69C 178.5,69.6667 176.5,69.6667 174.5,69C 172.457,65.7466 170.29,62.5799 168,59.5C 167.502,62.8168 167.335,66.1501 167.5,69.5C 165.833,69.5 164.167,69.5 162.5,69.5C 162.5,60.8333 162.5,52.1667 162.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#eeeeee",
    d: "M 167.5,47.5 C 172.984,47.4809 174.65,49.9809 172.5,55C 170.866,55.4935 169.199,55.6602 167.5,55.5C 167.5,52.8333 167.5,50.1667 167.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#030303",
    d: "M 158.5,48.5 C 155.833,48.5 153.167,48.5 150.5,48.5C 149.539,50.2646 149.205,52.2646 149.5,54.5C 152.5,54.5 155.5,54.5 158.5,54.5C 158.5,55.8333 158.5,57.1667 158.5,58.5C 155.5,58.5 152.5,58.5 149.5,58.5C 149.5,60.8333 149.5,63.1667 149.5,65.5C 152.5,65.5 155.5,65.5 158.5,65.5C 158.5,66.8333 158.5,68.1667 158.5,69.5C 154.167,69.5 149.833,69.5 145.5,69.5C 145.5,61.1667 145.5,52.8333 145.5,44.5C 149.833,44.5 154.167,44.5 158.5,44.5C 158.5,45.8333 158.5,47.1667 158.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#4c4c4c",
    d: "M 158.5,48.5 C 158.5,47.1667 158.5,45.8333 158.5,44.5C 154.167,44.5 149.833,44.5 145.5,44.5C 145.5,52.8333 145.5,61.1667 145.5,69.5C 145.167,69.5 144.833,69.5 144.5,69.5C 144.5,60.8333 144.5,52.1667 144.5,43.5C 149.5,43.5 154.5,43.5 159.5,43.5C 159.784,45.4147 159.451,47.0813 158.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#121212",
    d: "M 117.5,43.5 C 119.5,43.5 121.5,43.5 123.5,43.5C 125.092,49.356 127.258,55.0227 130,60.5C 132.742,55.0227 134.908,49.356 136.5,43.5C 138.604,43.2011 140.604,43.5344 142.5,44.5C 138.56,53.3776 134.393,62.0443 130,70.5C 128.181,68.8743 126.848,66.8743 126,64.5C 123.258,57.436 120.425,50.436 117.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#080808",
    d: "M 42.5,43.5 C 44.1667,43.5 45.8333,43.5 47.5,43.5C 47.5,52.1667 47.5,60.8333 47.5,69.5C 45.8333,69.5 44.1667,69.5 42.5,69.5C 42.5,60.8333 42.5,52.1667 42.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#121212",
    d: "M 29.5,44.5 C 38.7108,47.2533 41.8775,53.2533 39,62.5C 37.4371,65.7284 34.9371,67.8951 31.5,69C 27.5138,69.4988 23.5138,69.6655 19.5,69.5C 19.5,61.1667 19.5,52.8333 19.5,44.5C 22.8333,44.5 26.1667,44.5 29.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#fafafa",
    d: "M 24.5,48.5 C 33.1923,48.7012 36.3589,53.0345 34,61.5C 31.5923,64.6201 28.4257,65.9534 24.5,65.5C 24.5,59.8333 24.5,54.1667 24.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#6d6d6d",
    d: "M 29.5,44.5 C 26.1667,44.5 22.8333,44.5 19.5,44.5C 19.5,52.8333 19.5,61.1667 19.5,69.5C 18.507,61.0161 18.1736,52.3494 18.5,43.5C 22.3714,43.185 26.0381,43.5184 29.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#151515",
    d: "M 78.5,43.5 C 82.2148,43.423 85.8815,43.7564 89.5,44.5C 89.7989,46.604 89.4656,48.604 88.5,50.5C 78.5074,46.3208 74.0074,49.6541 75,60.5C 78.5103,65.7891 83.0103,66.7891 88.5,63.5C 89.7596,65.3529 89.7596,67.1862 88.5,69C 74.3544,71.8584 68.1877,66.025 70,51.5C 72.0738,47.9231 74.9072,45.2565 78.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#101010",
    d: "M 55.5,43.5 C 59.5762,43.1207 63.2429,44.1207 66.5,46.5C 65.8551,47.646 65.0217,48.646 64,49.5C 60.7631,46.5051 58.2631,46.8384 56.5,50.5C 56.6082,51.4419 56.9415,52.2753 57.5,53C 68.7149,55.9946 70.3816,61.6613 62.5,70C 57.3626,71.5512 53.3626,70.2179 50.5,66C 50.9304,64.5659 51.7638,63.3992 53,62.5C 56.5359,66.6493 59.7025,66.4826 62.5,62C 62.3552,61.228 62.0219,60.5613 61.5,60C 57.963,58.7191 54.7963,56.8857 52,54.5C 50.6628,49.9159 51.8295,46.2493 55.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#ec7e35",
    d: "M 64.5,124.5 C 106.663,125.499 148.997,125.832 191.5,125.5C 146.833,126.833 102.167,126.833 57.5,125.5C 59.861,125.326 62.1944,124.993 64.5,124.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovercarddisabled);
export default __webpack_public_path__ + "static/media/discovercarddisabled.425b797572f5d6c9f5db11f4a6bdaf1d.svg";
export { ForwardRef as ReactComponent };